import React, { Component } from 'react';
import {  observer } from 'mobx-react'

interface IPropsIconeSubscrito {
    fill?: string;
    zoom?:string;
    rigth?:string
    children: any;
}


class IconeSubscrito extends React.Component<React.PropsWithChildren<IPropsIconeSubscrito>> {


    render() {
        return (
            <svg style={{ width: '24px', height: '24px', zoom: this.props.zoom || '63%', position: 'absolute', top: -5, right: this.props.rigth || '5px', borderRadius: '10px', backgroundColor: 'var(--fundo-indicador-minuta, white)', fill: this.props.fill ? this.props.fill : 'inherit' }} className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root">
                {this.props.children}
            </svg>
        );
    }
}

export default observer(IconeSubscrito);
